import { Controller } from '@hotwired/stimulus'
import { DirectUpload } from '@rails/activestorage'

export default class extends Controller {
  static targets = ['input', 'status']

  declare readonly inputTarget: HTMLInputElement
  declare readonly statusTarget: HTMLElement

  preview (): void {
    const file = this.inputTarget.files?.[0]
    if (file == null) return

    this.statusTarget.textContent = `Preparing upload: ${file.name}`

    const upload = new DirectUpload(file, this.inputTarget.dataset.directUploadUrl!, this)

    upload.create((error, blob) => {
      if (error) {
        this.statusTarget.textContent = `❌ Upload failed: ${error}`
      } else {
        this.statusTarget.textContent = `✅ Uploaded: ${file.name}`
      }
    })
  }

  directUploadWillStoreFileWithXHR (request: XMLHttpRequest): void {
    request.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100)
        this.statusTarget.textContent = `Uploading ${this.inputTarget.files?.[0].name}: ${percent}%`
      }
    })
  }
}
